import NotificationsPopover from './NotificationsPopover';

export default NotificationsPopover;
